import Api from './api';
import AuthService from './auth';
import CustomerService from './customer';
import ServerService from './server';

export {
  CustomerService,
  AuthService,
  ServerService,
};

export default Api;
